<!-- THROW AWAY COMPONENT, REMOVE AFTER THE DEMO -->

<ng-container *ngIf="vm$ | async as vm">
	<ng-container [ngSwitch]="vm.state">
		<ng-container *ngSwitchCase="STATES.REVIEW">
			<ui-content-header
				title="{{
					_data.syncFlowType === 'email'
						? 'Review & Download'
						: 'Review & Send to Lender'
				}}"
				type="dialog"
			>
				<ui-button actions icon="x" preset="ICON_DEFAULT" (click)="back()" />
			</ui-content-header>
			<div class="flex h-full">
				<form
					#form="ngForm"
					(ngSubmit)="
						_data.syncFlowType === 'email'
							? downloadFiles(form)
							: uploadDocument(form)
					"
					class="basis-2/5 flex flex-col"
				>
					<div class="flex flex-col gap-6 p-6">
						<input class="opacity-0 absolute -z-0" type="password" />
						<div class="pt-4">
							<div class="w-32 mb-4">
								<img src="/assets/images/integrations/sync-inline-logo.png" />
							</div>
							<h4 class="h4">Digital Signature Required</h4>
							<ng-container
								*ngIf="{
									assignedLawyer: assignedLawyer$ | async,
									userId: userId$ | async,
								} as ctx"
							>
								<p *ngIf="ctx?.userId === ctx?.assignedLawyer?.id" class="p">
									This package requires your digital signature. To apply it,
									enter your Security PIN.
								</p>
								<p *ngIf="ctx?.userId !== ctx?.assignedLawyer?.id" class="p">
									This package requires
									<span class="font-semibold"
										>{{ ctx?.assignedLawyer?.firstName }}
										{{ ctx?.assignedLawyer?.lastName }}'s</span
									>
									digital signature. To apply it, enter their Security PIN.
								</p>
							</ng-container>
						</div>
						<div>
							<app-input
								label="Security PIN"
								placeholder="Enter Security PIN"
								type="password"
								[(ngModel)]="vm.pin"
								[submitted]="vm.submitted"
								[required]="true"
								name="syncPin"
							></app-input>
						</div>
						<ui-note
							type="custom"
							title="Sync PIN Guidance"
							icon="info-square-rounded"
						>
							<ng-container
								*ngIf="{
									assignedLawyer: assignedLawyer$ | async,
									userId: userId$ | async,
								} as ctx"
							>
								<p class="p-sm" *ngIf="ctx?.userId === ctx?.assignedLawyer?.id">
									This PIN was made during initial connection to the
									integration. Check your Sync Settings if you forget your PIN.
									<ui-anchor
										href="/app/profile/integrations/closer-sync?settings=open"
										>Sync Settings.</ui-anchor
									>
								</p>
								<p class="p-sm" *ngIf="ctx?.userId !== ctx?.assignedLawyer?.id">
									Contact
									<span class="font-semibold"
										>{{ (assignedLawyer$ | async)?.firstName }}
										{{ (assignedLawyer$ | async)?.lastName }}</span
									>
									for assistance.
								</p>
							</ng-container>
						</ui-note>
						<app-input
							*ngIf="_data.syncFlowType !== 'email'"
							[labelIcon]="ICON.INFO"
							labelToolTip="This name will be used to label your package in Document History."
							label="Package Name"
							[(ngModel)]="vm.fileName"
							[required]="true"
							autocomplete="off"
							[submitted]="vm.submitted"
							name="packageName"
						></app-input>
						<app-checkbox
							name="verify"
							type="clear"
							[(ngModel)]="vm.verifyContent"
							[required]="true"
							class="p-sm"
							[submitted]="vm.submitted"
						>
							I have verified the accuracy of the contents of this package.
						</app-checkbox>
					</div>
					<div *ngIf="vm.errorSending">
						There was an issue sending your package to the lender. Please try
						again.
					</div>
					<div class="flex flex-col gap-4 mt-auto p-6 border-t">
						<ui-button
							[fullWidth]="true"
							label="Download"
							icon="download"
							[loading]="vm.sending"
							[disabled]="!form.valid || !vm.verifyContent"
							type="submit"
							[matTooltip]="
								!form.valid ? 'You are missing required fields.' : null
							"
							*ngIf="
								_data.syncFlowType === SYNC_FLOW_TYPES.EMAIL;
								else sendButton
							"
						></ui-button>
						<ng-template #sendButton>
							<ui-button
								[fullWidth]="true"
								icon="send-2"
								label="Send to Lender"
								[loading]="vm.sending"
								[disabled]="!form.valid || !vm.verifyContent"
								type="submit"
								[matTooltip]="
									!form.valid ? 'You are missing required fields.' : null
								"
							></ui-button>
						</ng-template>
					</div>
				</form>
				<div class="basis-3/5">
					<app-pdftron
						[disabledElements]="['menuButton']"
						[base64Encoded]="vm.fileBase64"
					></app-pdftron>
				</div>
			</div>
		</ng-container>
		<ng-container *ngSwitchCase="STATES.ERROR_LOADING">
			<div
				class="flex flex-col w-full h-full justify-center items-center gap-14"
			>
				<div class="w-96">
					<img src="/assets/images/integrations/sync-inline-logo.png" />
				</div>
				<div class="flex flex-col gap-4 justify-center items-center">
					<h4>
						Something didn't go right. We were unable to generate your document
					</h4>
					<ui-button label="Retry" (click)="load()"></ui-button>
				</div>
			</div>
		</ng-container>
		<ng-container *ngSwitchCase="STATES.LOADING">
			<div
				class="flex flex-col w-full h-full justify-center items-center gap-14"
			>
				<div class="w-96">
					<img src="/assets/images/integrations/sync-inline-logo.png" />
				</div>
				<div class="flex flex-col gap-4 justify-center items-center">
					<h4>Generating your package</h4>
					<img
						src="/assets/images/integrations/sync-icon.png"
						class="w-10 animate-reverse-spin"
					/>
				</div>
			</div>
		</ng-container>
		<ng-container *ngSwitchCase="STATES.SENDING">
			<div
				class="flex flex-col w-full h-full justify-center items-center gap-14"
			>
				<div class="w-96">
					<img src="/assets/images/integrations/sync-inline-logo.png" />
				</div>
				<div class="flex flex-col gap-4 justify-center items-center">
					<h4>Sending package to lender</h4>
					<img
						src="/assets/images/integrations/sync-icon.png"
						class="w-10 animate-reverse-spin"
					/>
				</div>
			</div>
		</ng-container>
		<ng-container *ngSwitchCase="STATES.SENT">
			<div
				*ngIf="assignedLawyer$ | async as lawyer"
				class="flex flex-col items-center justify-center w-full h-full p-6"
			>
				<h2 class="h2 mb-4">Your Package Is On The Way!</h2>
				<p class="p max-w-2xl mb-8 text-center">
					Your package is being sent to {{ data.lenderName }} using
					{{ lawyer.lsoFaxNumber }}. You can review all sent packages and lender
					transmission receipts in the Document History tab.
				</p>
				<span
					class="flex flex-row justify-center align-middle items-center my-2 w-96"
					><img
						src="/assets/images/undraw/undraw_messaging_fun_re_vic9.svg"
						alt="Closer SYNC"
				/></span>
			</div>
			<div class="p-6 ml-auto">
				<ui-button label="Close" (click)="back()"></ui-button>
			</div>
		</ng-container>
	</ng-container>
</ng-container>
